import { apiRequest } from './api.js';

export async function listAdmins() {
  const data = await apiRequest('/users');
  return data?.data?.users || [];
}

export async function inviteAdmin({ name, email, role }) {
  return apiRequest('/users/invite', {
    method: 'POST',
    body: JSON.stringify({ name, email, role: role || 'admin' }),
  });
}

export async function updateAdmin(id, { name, role, status }) {
  return apiRequest(`/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ name, role, status }),
  });
}

export async function sendAdminPassword(id) {
  return apiRequest(`/users/${id}/password`, { method: 'POST' });
}

export async function deleteAdmin(id) {
  return apiRequest(`/users/${id}`, { method: 'DELETE' });
}
